
<app-daily-balance-chart [data]="data()" [loading]="resource.isLoading()"></app-daily-balance-chart>



